import toolsScript from 'raw-loader!./unlayer-product-image.js.raw'
//console.debug('toolsScript', toolsScript);
/*
const column = {
  "contents": [{
    "type": "custom",
    "slug": "dreamroi_product_image",
    "values": {
      "height": "200",
      "containerPadding": "5px",
      "_meta": {
        "htmlClassNames": "u_content_custom_dreamroi_product_image"
      },
      "selectable": true,
      "draggable": true,
      "duplicatable": true,
      "deletable": true,
      "hideable": true
    }
  }, {
    "type": "text",
    "values": {
      "containerPadding": "5px",
      "color": "#000000",
      "textAlign": "left",
      "lineHeight": "140%",
      "linkStyle": {
        "inherit": true,
        "linkColor": "#0000ee",
        "linkHoverColor": "#0000ee",
        "linkUnderline": true,
        "linkHoverUnderline": true
      },
      "_meta": {
        "htmlClassNames": "u_content_text"
      },
      "selectable": true,
      "draggable": true,
      "duplicatable": true,
      "deletable": true,
      "text": "<p style=\"font-size: 14px; line-height: 140%; text-align: center;\"><span style=\"color: #000000; font-size: 14px; line-height: 19.6px;\"><a style=\"color: #000000;\" href=\"{{ PRODUCT_URL }}\" target=\"_blank\" data-u-link-value=\"eyJuYW1lIjoid2ViIiwiYXR0cnMiOnsiaHJlZiI6Int7aHJlZn19IiwidGFyZ2V0Ijoie3t0YXJnZXR9fSJ9LCJ2YWx1ZXMiOnsiaHJlZiI6Int7IFBST0RVQ1RfVVJMIH19IiwidGFyZ2V0IjoiX2JsYW5rIn19\">{{ PRODUCT_NAME }}</a></span><br />{{ PRODUCT_PRICE }}<br />{{ PRODUCT_SALE }}%</p>"
    }
  }, {
    "type": "button",
    "values": {
      "containerPadding": "10px",
      "href": {
        "name": "web",
        "attrs": {
          "href": "{{href}}",
          "target": "{{target}}"
        },
        "values": {
          "href": "{{ PRODUCT_URLBTN }}",
          "target": "_blank"
        }
      },
      "buttonColors": {
        "color": "#FFFFFF",
        "backgroundColor": "#000000",
        "hoverColor": "#FFFFFF",
        "hoverBackgroundColor": "#3AAEE0"
      },
      "size": {
        "autoWidth": true,
        "width": "100%"
      },
      "textAlign": "center",
      "lineHeight": "120%",
      "padding": "10px 20px",
      "border": {},
      "borderRadius": "4px",
      "_meta": {
        "htmlClassNames": "u_content_button"
      },
      "selectable": true,
      "draggable": true,
      "duplicatable": true,
      "deletable": true,
      "text": "<span style=\"font-size: 14px; line-height: 16.8px;\">KOUPIT</span>",
      "calculatedWidth": 92,
      "calculatedHeight": 36
    }
  }],
  "values": {
    "_meta": {
      "htmlClassNames": "u_column"
    }
  }
};

const block = (columns, tags) => {
  return {
    "category": "DreamROI",
    "tags": tags,
    "data": {
      "cells": Array(columns).fill(1),
      "columns": Array(columns).fill(column),
      "values": {
        "displayCondition": null,
        "columns": false,
        "backgroundColor": "",
        "columnsBackgroundColor": "",
        "backgroundImage": {
          "url": "",
          "fullWidth": true,
          "repeat": false,
          "center": true,
          "cover": false
        },
        "padding": "20px 0px",
        "hideDesktop": false,
        "_meta": {
          "htmlClassNames": "u_row"
        },
        "selectable": true,
        "draggable": true,
        "duplicatable": true,
        "deletable": true
      }
    },
    "displayMode": "email"
  }
}
*/
export default (i18n, productCategories) => {
  //TODO remove condition
  let cjs = parseInt(process.env.VUE_APP_UNLAYER_CUSTOM_TOOL) ? toolsScript : '';
  Object.keys(i18n).forEach(t => cjs = cjs.replace(new RegExp(`%${t.toUpperCase()}%`, 'g'), i18n[t]));
  let boxTypeOptions = [
    {
      label: i18n['box_rec'],
      value: 'R'
    },
    {
      label: i18n['box_new'],
      value: 'N'
    }
  ];
  if(productCategories.length > 0) {
    cjs = cjs.replace(/%DEFAULT_CATEGORY%/g, productCategories[0].value);
    console.log('customjs',cjs);
    boxTypeOptions.push({
      label: i18n['box_cat'],
      value: 'C'
    });
  }
  
  return {
    customJS: [ cjs ], //'http://localhost:8080/unlayer/unlayer-product-image.js', //[`console.log('Custom JS called!')`], //'//unlayer/unlayer-product-image.js',
    tools: {
      'custom#dreamroi_product_image': {
        properties: {
          boxType: {
            editor: {
              data: {
                options: boxTypeOptions
              }
            }
          },
          productCategory: {
            editor: {
              data: {
                options: productCategories
              }
            }
          }
        }
      }
    },   
    mergeTags: {
            productName: {
                name: "Product name",
                value: "{{ PRODUCT_NAME }}",
                sample: "Product name"
            },
            productImage: {
                name: "Product image URL",
                value: "{{ PRODUCT_IMAGE }}",
                sample: "https://placehold.co/200x200/png?text=PRODUCT+IMAGE"
            },
            productDescription: {
                name: "Product description",
                value: "{{ PRODUCT_DESCRIPTION }}",
                sample: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Duis viverra diam non justo. Nam sed tellus id magna elementum tincidunt. Etiam bibendum elit eget erat."
            },
            productPrice: {
                name: "Product price",
                value: "{{ PRODUCT_PRICE }}",
                sample: "$99.99"
            },
            productSale: {
                name: "Product sale (%)",
                value: "{{ PRODUCT_SALE }}",
                sample: "50"
            },
            productOriginalPrice: {
              name: "Original product price",
              value: "{{ PRODUCT_ORIGINAL_PRICE }}",
              sample: "$199.99"
          },
        },
        specialLinks: [
            {
                name: 'Unsubscribe',
                href: '{{ UNSUBSCRIBE }}',
                target: '_self',
            },
            {
                name: 'Product link',
                href: '{{ PRODUCT_URL }}',
                target: '_self',
            },
            {
                name: 'Product link (for button)',
                href: '{{ PRODUCT_URLBTN }}',
                target: '_self',
            },
            {
                name: 'Product link (for image)',
                href: '{{ PRODUCT_URLIMG }}',
                target: '_self',
            },
        ],
        /*
        blocks: [
          block(1, ['Produkt', '1 sloupec']),
          block(2, ['Produkt', '2 sloupce']),
          block(3, ['Produkt', '3 sloupce']),
          block(4, ['Produkt', '4 sloupce'])
        ]
        */
}}